import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ActionCardContentProps {
  children: React.ReactNode;
}

const ContentComponent: React.FC<ActionCardContentProps> = ({ children }) => {
  return <div className="peptalk-action-card-content">{children}</div>;
};

export const Content: React.FC<ActionCardContentProps> = (
  props: ActionCardContentProps
) => {
  const Component = useCustomComponent({
    componentName: 'ActionCardContent',
    Component: ContentComponent,
  });

  return <Component {...props} />;
};
